import { render } from "./BrandList.vue?vue&type=template&id=213fed4a&scoped=true"
import script from "../js/brand-list.js?vue&type=script&lang=js"
export * from "../js/brand-list.js?vue&type=script&lang=js"

import "./BrandList.vue?vue&type=style&index=0&id=213fed4a&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213fed4a"]])

export default __exports__